import { render, staticRenderFns } from "./section-discount.vue?vue&type=template&id=41b85d84&scoped=true&"
import script from "./section-discount.vue?vue&type=script&lang=js&"
export * from "./section-discount.vue?vue&type=script&lang=js&"
import style0 from "./section-discount.vue?vue&type=style&index=0&id=41b85d84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b85d84",
  null
  
)

export default component.exports